import script from "./SignInWelcomePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignInWelcomePage.vue?vue&type=script&setup=true&lang=ts"

import "./SignInWelcomePage.vue?vue&type=style&index=0&id=7213636c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7213636c"]])

export default __exports__